import { CommonData }  from '@/types/commonData'
import { getJsonData } from '@/utils/dom'
import ICON_MY_FLAG from 'common/icon-my-flag.svg'
import ICON_SG_FLAG from 'common/icon-sg-flag.svg'
export interface Region {
  region: string
  currency: string
  currencySymbol: string | any
  locale: string
  flag: string,
  name: string,
  url: string
}

const commonData: CommonData = getJsonData('#commonData') || undefined

export const custaRegions: Region[] = [
  {
    region:'my',
    currency: 'MYR',
    currencySymbol: 'RM',
    locale: 'ms',
    flag: ICON_MY_FLAG,
    name: 'Malaysia',
    url: commonData.custa_urls.my
  },
  {
    region:'sg',
    currency: 'SGD',
    currencySymbol: '$', //\u0024
    locale: 'en-SG',
    flag: ICON_SG_FLAG,
    name: 'Singapore',
    url: commonData.custa_urls.sg
  }
]

export const getRegion = (): Region | undefined => {
  const custaRegion = commonData.custa_region
  const region = custaRegions.find(r => r.region === custaRegion)
  return region ? region : undefined
}

export const currencySymbol: string = getRegion()?.currencySymbol

export const countRemainingTimeForShipping = (revisionDeadline = '') => {
  const date = new Date()
  const currentTime = date.getTime()
  const closeDate = revisionDeadline ? revisionDeadline : date.toDateString() + ' 15:00:00 GMT+9'
  const closeTime = new Date(closeDate).getTime()

  let milliseconds

  if (currentTime >= closeTime) {
    milliseconds = closeTime - currentTime + 86400 * 1000
  } else {
    milliseconds = closeTime - currentTime
  }

  const hours = Math.floor(milliseconds / 3600 / 1000)
  const dayLeft = Math.floor(hours / 24)
  const hourLeft = hours % 24
  const minutes = Math.floor((milliseconds - hours * 3600 * 1000) / (1000 * 60))

  const dayString = dayLeft !== 0 && revisionDeadline !== '' ? dayLeft + ' day(s)' : ''
  const hourString = hourLeft !== 0 ? hourLeft + ' hour(s)' : ''
  const minString = minutes !== 0 ? minutes + ' minute(s) remaining' : ''

  return dayString + hourString + minString
}

export const formatOneDecimal = (inputPrice?: string | number) => {
  if (!inputPrice) return '0.00'
    // Convert to number if the input is a string
    const numericPrice: number = typeof inputPrice === 'string' ? parseFloat(inputPrice) : inputPrice
    // Check if the input is a valid number
    if (isNaN(numericPrice)) {
        throw new Error('Invalid input. Please provide a valid number or string representation of a number.')
    }
    // Format the number to two decimal places
    const formattedPrice: string = numericPrice.toFixed(2)
    const priceWithDelimiter = formattedPrice.split('.')
    priceWithDelimiter[0] = priceWithDelimiter[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    return priceWithDelimiter.join('.')
}

export const normalizeNumber = (input: string) => {
  const normalize = input.replace(/[\uFF10-\uFF19]/g, function(value: any) {
    return String.fromCharCode(value.charCodeAt(0) - 0xfee0)
  })
  return Number(normalize)
}
